var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "bubble",
      attrs: {
        id: "bubbleButton",
        type: "button",
        "aria-label": _vm.buttonLabel,
      },
      on: { click: _vm.handleBubbleClicked },
    },
    [
      _c("transition", { attrs: { name: "toggling-bubble" } }, [
        !_vm.isOpen
          ? _c("div", [
              _vm.chosenAvatarImage
                ? _c("img", {
                    staticClass: "avatar-in-bubble",
                    attrs: {
                      src: _vm.chosenAvatarImage,
                      alt: _vm.headerTitle,
                      "aria-labelledby": "bubbleButton",
                    },
                  })
                : _vm._e(),
            ])
          : _c("div", [
              !_vm.isOpen
                ? _c(
                    "svg",
                    {
                      key: "open",
                      staticClass: "chat-icon-trigger svg-block",
                      attrs: {
                        viewBox: "0 0 30 30",
                        width: "32",
                        "aria-labelledby": "bubbleButton",
                      },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href": "#icon-chat",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
            ]),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "toggling-bubble" } }, [
        _vm.isOpen
          ? _c(
              "svg",
              {
                key: "close",
                staticClass: "chat-icon-trigger svg-block",
                attrs: { viewBox: "0 0 30 30", width: "24", fill: "white" },
              },
              [
                _c("use", {
                  attrs: {
                    "xlink:href": "#icon-close",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  },
                }),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }